<div
  class="kl-field"
  [class.kl-field--my-3]="marginY()"
  [class.kl-field--mb-2]="marginBottom()"
  [formGroup]="formGroup()">
  @if (label()) {
    <kl-label
      [label]="label()"
      [labelDescription]="labelDescription()"
      [isRequired]="required()"
      [htmlFor]="fieldId()" />
  }

  <div class="kl-field__control text-start">
    @if (bindWholeObject()) {
      <p-listbox
        class="kl-listbox"
        [attr.id]="fieldId()"
        [options]="options()"
        [optionLabel]="optionLabel()"
        [dataKey]="dataKey() ?? 'id'"
        [multiple]="multiple()"
        [checkbox]="checkbox()"
        [filter]="filter()"
        [formControlName]="controlName()"
        [disabled]="disabled()"
        [style]="listStyle()"
        [invalid]="showInvalid()"
        (onChange)="onAnyChange()" />
    } @else {
      <p-listbox
        class="kl-listbox"
        [attr.id]="fieldId()"
        [options]="options()"
        [optionLabel]="optionLabel()"
        [optionValue]="optionValue()"
        [multiple]="multiple()"
        [checkbox]="checkbox()"
        [filter]="filter()"
        [formControlName]="controlName()"
        [disabled]="disabled()"
        [style]="listStyle()"
        [invalid]="showInvalid()"
        (onChange)="onAnyChange()" />
    }
  </div>

  @if (showFieldError()) {
    <div class="kl-field__error text-start">
      @if (controlError()) {
        <span>{{ controlError() }}</span>
      }
    </div>
  }
</div>
